import { render, staticRenderFns } from "./KeyIndicatorHk.vue?vue&type=template&id=1221bf70&scoped=true"
import script from "./KeyIndicatorHk.vue?vue&type=script&lang=js"
export * from "./KeyIndicatorHk.vue?vue&type=script&lang=js"
import style0 from "./KeyIndicatorHk.vue?vue&type=style&index=0&id=1221bf70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221bf70",
  null
  
)

export default component.exports